<template>
  <div class="panel_two">
    <h3>查询结果</h3>
    <div class="list">
      <div class="item" v-for="item in data" :key="item.key">
        <span>{{ item.title }}</span>
        <span>{{ detail[item.key] }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue'
export default {
  props:['detail'],
  computed: {
    data() {
      return this.detail.type == 1 ? [
        { title: '报告编号', key: 'number' },
        { title: '报告客户', key: 'customer' },
        { title: '产品名称', key: 'name' },
        { title: '型号', key: 'model' },
        { title: '签发日期', key: 'recordDate' },
      ] : [
        { title: '报告/证书编号', key: 'number' },
        { title: '报告/证书客户', key: 'customer' },
        { title: '仪器名称', key: 'name' },
        { title: '型号/规格', key: 'model' },
        { title: '出厂编号', key: 'factoryNo' },
        { title: '设备编号', key: 'ref' },
        { title: '校准人员', key: 'worker' },
        { title: '校准日期', key: 'recordDate' },
      ]
    }
  },
}
</script>

<style lang='scss'>
  .panel_two {
    background: #ffffff;
    border-radius: 10px;
    box-shadow: 0px 5px 20px 0px rgba(0,41,98,0.10); 
    margin: 20px auto 0;

    & > h3 {
      line-height: 33px;
      font-size: 24px;
      font-weight: 600;
      color: #303133;
      margin-bottom: 25px;
    }

    .list {
      .item {
        margin-bottom: 20px;
        display: flex;
        font-size: 14px;
        line-height: 20px;
        align-items: center;

        & > span {
          &:first-child {
            width: 120px;
            color: #86909c;
            margin-right: 20px;
            flex-shrink: 0;
          }

          &:last-child {
            color: #1d2129;
          }
        }
      }
    }
  }
</style>